module.exports = __webpack_public_path__ + "img/collection-engagementRings050Carat@2x.187fad7.webp";